import { render } from "./GameComponent.vue?vue&type=template&id=ccd09e4c&scoped=true"
import script from "./GameComponent.vue?vue&type=script&lang=js"
export * from "./GameComponent.vue?vue&type=script&lang=js"

import "./GameComponent.vue?vue&type=style&index=0&id=ccd09e4c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccd09e4c"]])

export default __exports__